import { PlazaCollectFeePage } from "./../plaza-collect-fee/plaza-collect-fee";
import { PlazaTicketPage } from "./../plaza-ticket/plaza-ticket";
import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { PlazaSelectPlanChoosePage } from "./../plaza-select-plan-choose/plaza-select-plan-choose";
import { RequestOptions, Http, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-select-plan",
  templateUrl: "plaza-select-plan.html",
})
export class PlazaSelectPlanPage {
  spaces: any = [1, 2];
  theme = 1;
  socialSelected = [];

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLSpaces;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
            this.spaces.forEach((element) => {
              if (element.socialShop != null) {
                this.socialSelected.push(element.socialShop.social_shop_id);
              }
            });
            // console.log("socialSelected===>", this.socialSelected);
            this.storage.set("socialSelected", this.socialSelected);

            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLSpaces;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  ticketSocial(space) {
    this.navCtrl.push(PlazaTicketPage, { space: space });
  }

  collectFee(space) {
    this.navCtrl.push(PlazaCollectFeePage, { space: space });
  }

  backPage() {
    this.navCtrl.setRoot(HomePage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  choosePage(space) {
    this.navCtrl.push(PlazaSelectPlanChoosePage, { space: space });
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan/plaza-select-plan.ts